import React from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
// import logo from "./logo.svg";
// import "./App.css";
import Home from "./pages/home";
import Travel from "./pages/travel";
import Guides from "./pages/guides";
import Food from "./pages/food";
import Hotels from "./pages/hotels";
import Privacy from "./pages/privacy";

import Article from "./pages/article";
import MorePage from "./pages/morepage";
import Search from "./pages/search";
// import AIPlanner from "./pages/ai-planner";
import TestAnswer from "./pages/test-answer";
import VideoPage from "./pages/videopage";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/travel" element={<Travel />} />

          <Route path="/guides" element={<Guides />} />

          <Route path="/food" element={<Food />} />

          <Route path="/hotels" element={<Hotels />} />

          <Route path="/privacy" element={<Privacy />} />

          {/* <Route path="/article" element={<Article />} /> */}
          <Route path="/article/:slug" element={<Article />} />

          <Route path="/morepage" element={<MorePage />} />

          <Route path="/search" element={<Search />} />
          <Route path="/search/:keyword" element={<Search />} />

          {/* <Route path="/ai-planner" element={<AIPlanner />} /> */}

          <Route path="/test-answer" element={<TestAnswer />} />

          <Route path="/videopage" element={<VideoPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
